// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__-ijHN","col":"CardReaderDesc_col__2ZwSa","label":"CardReaderDesc_label__lg1hW"};